import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';
import Loading from '@/shared/components/Loading';
import Router from './Router';
import ScrollToTop from './ScrollToTop';
import GlobalStyles from './globalStyles';
import NotificationStyles from './notificationStyles';
import { AuthProvider } from '@/context/AuthContext';

const App = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const handleLoad = () => {
      setIsLoading(false);
      setTimeout(() => setIsLoaded(true), 500);
    };

    window.addEventListener('load', handleLoad);
    return () => window.removeEventListener('load', handleLoad);
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop>
          {!isLoaded && isLoading && <Loading />}
          <ThemeProvider
            theme={{
              mode: 'light',
              direction: 'ltr',
            }}
          >
            <NotificationStyles />
            <GlobalStyles />
            <Router />
          </ThemeProvider>
        </ScrollToTop>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
